// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"90c51f28","783":"65ab6d4a"}[chunkId] + ".chunk.css";
};